import React from 'react';
import Select, { SelectChangeEvent } from '@mui/material/Select';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import InputLabel from '@mui/material/InputLabel';
import translationsJson from 'data/translations.json';
import { SexSelection } from 'lib/Types';

const translations: Translations = translationsJson;

interface Props {
    onUpdate(sex: SexSelection): void;
    young: boolean;
}

class GenderFilter extends React.Component<Props, { currentValue: SexSelection }> {
    constructor(props: Props) {
        super(props);
        this.state = {
            currentValue: SexSelection.All
        }

        this.onChange = this.onChange.bind(this);
    }

    private onChange(event: SelectChangeEvent<unknown>, child: React.ReactNode) {
        const sex = String(event.target.value);
        let sexSelection = SexSelection.All;
        if (sex === SexSelection.Male)
            sexSelection = SexSelection.Male;
        else if (sex === SexSelection.Female)
            sexSelection = SexSelection.Female;

        this.setState({ currentValue: sexSelection });
        if (this.props.onUpdate) {
            this.props.onUpdate(sexSelection);
        }
    }

    render() {
        return (
            <FormControl className="dropdown">
                <InputLabel id="dropdown-label">{translations.gender[window.lang]}</InputLabel>
                <Select labelId="dropdown-label" id="dropdown-select" onChange={this.onChange} value={this.state.currentValue} label={translations.gender[window.lang]}>
                    <MenuItem value={SexSelection.All}>{translations.all[window.lang]}</MenuItem>
                    <MenuItem value={SexSelection.Male}>{this.props.young ? translations.malesYoung[window.lang] : translations.males[window.lang]}</MenuItem>
                    <MenuItem value={SexSelection.Female}>{this.props.young ? translations.femalesYoung[window.lang] : translations.females[window.lang]}</MenuItem>
                </Select>
            </FormControl>
        );
    }
}

export default GenderFilter;